import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { TrashIcon } from 'src/domains/layouts/shared/assets/icons/TrashIcon';
import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';

export const OptionTextContainer = withConfig(theme => styled('div', { label: 'OptionTextContainer' })`
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.xMedium};
    display: flex;
    flex-direction: column;
    line-height: ${theme.star.fontSize.xMedium};

    .react-select__option--is-disabled & {
        color: ${theme.star.paymentMethodDropdown.txtColor};
    }
`);

export const SubtitleContainer = withConfig(theme => styled('div', { label: 'SubtitleContainer' })`
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    display: flex;
    align-items: center;
    line-height: ${theme.star.fontSize.small};
    color: ${theme.star.paymentMethodDropdown.txtColorQuaternary};

    .react-select__option--is-selected & {
        color: ${theme.star.paymentMethodDropdown.txtColorQuinary};
    }

    .react-select__option--is-disabled & {
        color: ${theme.star.paymentMethodDropdown.txtColorQuaternary};
    }
`);

export const StyledCheckIcon = styled(CheckSingleIcon, { label: 'StyledCheckIcon' })`
    fill: currentcolor;
    width: 20px;
    height: 15px;
`;

export const NewTrashIcon = withConfig(theme => styled(TrashIcon, { label: 'NewTrashIcon' })`
    fill: ${theme.star.paymentMethodDropdown.bgColor};
    width: 16px;
    cursor: pointer;
`);

export const NewTrashIconWrapper = withConfig(theme => styled('div', { label: 'NewTrashIconWrapper' })`
    background-color: ${theme.star.paymentMethodDropdown.bgColorQuaternary};
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
`);

export const Separator = withConfig(theme => styled('div', { label: 'Separator' })`
    background-color: ${theme.star.paymentMethodDropdown.bgColorQuinary};
    display: flex;
    height: 1px;
    width: 100%;
`);

export const SeparatorWrapper = styled('div', { label: 'SeparatorWrapper' })`
    padding: 3px 12px;
`;

